// Pure run-merging for the Data Availability grids — turns per-month flags into the segments the
// modal draws as one cell / one spanning chip each.
import { monthKeyToFyStartYear } from '../../../../../utils/dateUtils';
import type { MonthFlags } from '../../../../../store/reconciliations/types';

export type MonthSegment = { kind: 'present'; month: string } | { kind: 'missing'; months: string[] } | { kind: 'future'; month: string };

export type CoverageSegment = { kind: 'covered'; months: string[] } | { kind: 'uncovered'; month: string };

/** Months after `lastCompletedMonthKey` are `future` (unless the flag is true); consecutive false past months merge into one `missing` run. */
export function toMonthSegments(months: string[], flags: MonthFlags, lastCompletedMonthKey: string): MonthSegment[] {
    const segments: MonthSegment[] = [];
    for (const month of months) {
        if (flags[month] === true) {
            segments.push({ kind: 'present', month });
            continue;
        }
        if (month > lastCompletedMonthKey) {
            segments.push({ kind: 'future', month });
            continue;
        }
        const previous = segments[segments.length - 1];
        if (previous?.kind === 'missing') previous.months.push(month);
        else segments.push({ kind: 'missing', months: [month] });
    }
    return segments;
}

/** A month is covered when its April-start financial year is in `fys`; consecutive covered months merge. */
export function toCoverageSegments(months: string[], fys: number[]): CoverageSegment[] {
    const segments: CoverageSegment[] = [];
    for (const month of months) {
        if (!fys.includes(monthKeyToFyStartYear(month))) {
            segments.push({ kind: 'uncovered', month });
            continue;
        }
        const previous = segments[segments.length - 1];
        if (previous?.kind === 'covered') previous.months.push(month);
        else segments.push({ kind: 'covered', months: [month] });
    }
    return segments;
}
